module.exports = __webpack_public_path__ + "img/modal-cross-icon.b1b5d18f.svg";